import { Tselect } from '../../../api/modelAPI/detectedSensitiveWordLog'
import { DrowpDown } from '../../../assets/images/svg/icon'
import '../style.scss'
import DetectedSensitiveWordState from './enum/states'


type Props = {
    setSelect: Function,
    select:any
}

const StatusClient = ({ setSelect,select }: Props) => {
    return (
        <div className="d-flex justify-content-start align-items-center">
            <span>وضعیت مشترک:</span>
            <div className='select-wrapper'>
                <select className="form-control status-customer" value={select?.typeActivity===""?DetectedSensitiveWordState?.Block.toString():select?.statusCustomer} onChange={(e) => { setSelect({ statusCustomer: e.target.value }) }}>
                    <option disabled={select?.typeActivity===""?true:false}  value={DetectedSensitiveWordState?.New.toString()}>در انتظار بررسی</option>
                    <option   value={DetectedSensitiveWordState?.Block.toString()}>مسدود شده</option>
                    <option disabled={select?.typeActivity===""?true:false}  value={DetectedSensitiveWordState?.Ignore.toString()}>نادیده گرفته شده</option>
                    <option disabled={select?.typeActivity===""?true:false} value={DetectedSensitiveWordState?.InvestigationPending.toString()}>نیازمند پیگیری</option>
                </select>
                <span className="icon-selector"><DrowpDown /></span>
            </div>

        </div>
    )
}

export default StatusClient